// This is just for the Loading or Error Selector
export const GET_DEALERS = 'GET_DEALERS';

// Use these for Actions
export const GET_DEALERS_REQUEST = 'GET_DEALERS_REQUEST';
export const GET_DEALERS_SUCCESS = 'GET_DEALERS_SUCCESS';
export const GET_DEALERS_ERROR = 'GET_DEALERS_ERROR';
